import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class TaggedTemplateExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.TaggedTemplateExpression;
    }
    visitNode(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.callLike);
    }
}

//# sourceMappingURL=TaggedTemplateExpressionCompiler.js.map
